import { lazy } from 'react'

export const LocationSearchVariant1 = lazy(
  () => import('./LocationSearchVariant1'),
)
export const LocationSearchVariant2 = lazy(
  () => import('./LocationSearchVariant2'),
)
export const LocationSearchVariant3 = lazy(
  () => import('./LocationSearchVariant3'),
)
